module.exports = __webpack_public_path__ + "img/card-n.3def2e28.png";